import oRequest from '@/libsV2/request.js';
import store from '@/store/store';

const URL = {
    SERVICE_SCOREDETAIL: 'hvac/score/detail', // 项目评分详情
    SCOREDETAIL: 'hvac/score/detailp', // 项目评分详情
}


export const getScoredetail = (data = {}) => {
    store.commit("loadSwitch", true);
    return oRequest.getData(URL.SERVICE_SCOREDETAIL, data);
};
export const getScoreData = (data = {}) => {
    store.commit("loadSwitch", true);
    return oRequest.getData(URL.SCOREDETAIL, data);
};
